import type { HTMLAttributes, ReactNode } from 'react';
import type { LogParams } from '@application/api';
import type { ImageCropperModalData } from '../ImageCropperModal/types';

export interface InputFileFieldData {
  disabled?: boolean;
  iconOnly?: boolean;
  icon?: ReactNode;
  isImage?: boolean;
  imageCropperProps?: Omit<ImageCropperModalData, 'modal' | 'file'>;
  usePlusIcon?: boolean;
  multiple?: boolean;
  log?: (params: LogParams) => void;
}

export interface InputFileFieldProps extends HTMLAttributes<HTMLInputElement>, InputFileFieldData {
  name: string;
  accept?: string;
}
